<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Tab',
    props: ['title', 'titleSlot', 'disabled'],
});
</script>

<template>
    <div class="tab-panel" role="tabPanel">
        <div class="tab-content p-1"><slot /></div>
    </div>
</template>
